var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramCalendar40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 20 0 20 20 0 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 1 0 1 1 0 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "0 0 1 0 1 1 0 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "0 0 1 0 1 1 0 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "0 0 1 0 1 1 0 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-11",
    points: "0 0 1 0 1 1 0 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-13",
    points: "0 0 1 0 1 1 0 1"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-15",
    points: "0 0 1 0 1 1 0 1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,3 C2.3284275,3 3,2.3284275 3,1.5 C3,0.6715725 2.3284275,0 1.5,0 C0.6715725,0 0,0.6715725 0,1.5 C0,2.3284275 0.6715725,3 1.5,3 Z",
    id: "path-17"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pictos",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-34"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(10.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    points: "-2.17391304 -2.17391304 22.173913 -2.17391304 22.173913 22.173913 -2.17391304 22.173913"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(10.000000, 9.000000)",
    stroke: "#4F4C4D"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-4",
    points: "0 1.76 20 1.76 20 22 0 22"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.434782609,
    y1: 5.72,
    x2: 19.5652174,
    y2: 5.72,
    id: "Stroke-5",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.47826087,3.52 L3.47826087,0 L3.47826087,3.52 Z",
    id: "Stroke-6",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5512696,3.52 L16.5512696,0 L16.5512696,3.52 Z",
    id: "Stroke-7",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(13.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-10"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#4F4C4D",
    mask: "url(#mask-4)",
    points: "-2.5 -2.5 3.5 -2.5 3.5 3.5 -2.5 3.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(17.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#4F4C4D",
    mask: "url(#mask-6)",
    points: "-2.5 -2.5 3.5 -2.5 3.5 3.5 -2.5 3.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(22.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#4F4C4D",
    mask: "url(#mask-8)",
    points: "-2.5 -2.5 3.5 -2.5 3.5 3.5 -2.5 3.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(26.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-19"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-18",
    fill: "#4F4C4D",
    mask: "url(#mask-10)",
    points: "-2.5 -2.5 3.5 -2.5 3.5 3.5 -2.5 3.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(13.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-22"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-21",
    fill: "#4F4C4D",
    mask: "url(#mask-12)",
    points: "-2.5 -2.5 3.5 -2.5 3.5 3.5 -2.5 3.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(17.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-25"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#4F4C4D",
    mask: "url(#mask-14)",
    points: "-2.5 -2.5 3.5 -2.5 3.5 3.5 -2.5 3.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-29",
    transform: "translate(26.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-15"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-28"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-27",
    fill: "#4F4C4D",
    mask: "url(#mask-16)",
    points: "-2.5 -2.5 3.5 -2.5 3.5 3.5 -2.5 3.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-32",
    transform: "translate(21.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-17"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-31"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-30",
    fill: "#FFCC00",
    mask: "url(#mask-18)",
    points: "-1.875 -1.875 4.875 -1.875 4.875 4.875 -1.875 4.875"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,27 C23.3284271,27 24,26.3284271 24,25.5 C24,24.6715729 23.3284271,24 22.5,24 C21.6715729,24 21,24.6715729 21,25.5 C21,26.3284271 21.6715729,27 22.5,27 Z",
    id: "Stroke-33",
    stroke: "#4F4C4D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramCalendar40);
export default __webpack_public_path__ + "static/media/pictogramCalendar40.ffd9d338aa80e87df98def127f0ece21.svg";
export { ForwardRef as ReactComponent };